import { AddOutlined } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import { useListEmailTemplatesQuery } from 'api/client-domain/email-template-service/email-template-service';
import SearchDataCardGrid from 'components/search/search-data-card-grid/search-data-card-grid.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useSearch } from 'components/search/search.hooks';
import {
  booleanSearchParam,
  defaultSearchParams,
  querySearchParam,
  stringSearchParam,
} from 'components/search/search.utils';
import { useTranslation } from 'react-i18next';
import SearchDataCard from '../../search-data-card/search-data-card.component';
import { useGlobalDrawer } from 'components/drawers/global-drawer/global-drawer.hooks';
import { EmailTemplateTypes } from '../../email-templates.utils';
import { useHasPermission } from 'hooks/authorization.hooks';

const MessageEmails = () => {
  const { t } = useTranslation();

  const emailTemplates = useSearch(useListEmailTemplatesQuery, [
    ...defaultSearchParams({
      count: 9,
      page: 0,
    }),
    querySearchParam('name', { defaultValue: '' }),
    stringSearchParam('emailTemplateType', {
      defaultValue: EmailTemplateTypes.MESSAGE,
    }),
    booleanSearchParam('reusable', { defaultValue: true }),
  ]);

  const { open: openEmailTemplateDrawer } = useGlobalDrawer(
    'globalCreateEmailTemplateDrawer',
  );

  const hasCreatePermission = useHasPermission('CREATE_EDIT_EMAIL_TEMPLATES');

  return (
    <Box py={2}>
      <SearchProvider value={emailTemplates}>
        <Stack gap={3}>
          <SearchToolbar
            searchInputLabel={t(
              'page.communications.emailTemplates.tabs.messageEmails.searchInput.placeholder',
            )}
            buttons={
              hasCreatePermission ? (
                <Button
                  onClick={() =>
                    openEmailTemplateDrawer({
                      template: {
                        emailTemplateType: EmailTemplateTypes.MESSAGE,
                        reusable: true,
                      },
                    })
                  }
                  startIcon={<AddOutlined />}
                  data-testid="MessageEmailTemplate.Button.Create"
                  sx={{ whiteSpace: 'nowrap' }}
                  variant="text"
                >
                  {t(
                    'page.communications.emailTemplates.tabs.messageEmails.createButton',
                  )}
                </Button>
              ) : null
            }
          />
          <SearchDataCardGrid
            emptyDataText={t(
              'page.communications.emailTemplates.tabs.messageEmails.emptyDataText',
            )}
            CardComponent={SearchDataCard}
            data-testid="Message.SearchDataCardGrid"
          />
        </Stack>
      </SearchProvider>
    </Box>
  );
};

export default MessageEmails;
